module.exports = __webpack_public_path__ + "img/astral_7.75c8d5ab.svg";